<template>
  <div>
    <el-card class="bg_card">
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {
  },
  methods: {

  },
};
</script>
<style lang="less" scoped>
    .bg_card {
        height: 88vh;
        background: url("../assets/welcome.gif");
        background-size: cover;
    }
</style>
